var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _g2, _path1, _path10, _path11, _g3, _path12, _path13, _path14, _g4, _path15, _path16, _path17, _g5, _path18, _path19, _path20, _g6, _path21, _path22, _path23, _g7, _path24, _path25, _path26, _g8, _path27, _path28, _path29, _g9, _path30, _path31, _path32, _g0, _path33, _path34, _path35, _g1, _rect, _path36, _g10, _path37, _g11, _path38, _g12, _path39, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTourIconThree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 87,
    viewBox: "0 0 102 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_9034",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 45,
    width: 7,
    height: 7
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.0979 48.0634C6.6665 49.6151 7.5747 51.2228 9.12643 51.6542C10.6782 52.0856 12.2858 51.1774 12.7172 49.6256C13.1486 48.0739 12.2404 46.4663 10.6887 46.0348C9.13695 45.6034 7.52931 46.5116 7.0979 48.0634Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_9034)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_9034",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 46,
    width: 6,
    height: 6
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.46274 48.2594C7.85213 46.8588 9.30319 46.039 10.7038 46.4284C12.1044 46.8178 12.9241 48.2689 12.5347 49.6695C12.1454 51.0701 10.6943 51.8898 9.2937 51.5004C7.8931 51.1111 7.07335 49.66 7.46274 48.2594Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_9034)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1_9034",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 46,
    width: 6,
    height: 6
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7038 46.4284C9.30335 46.0391 7.85208 46.859 7.46274 48.2594C7.0734 49.6598 7.89326 51.1111 9.2937 51.5004C10.6941 51.8898 12.1454 51.0699 12.5347 49.6695C12.9241 48.269 12.1042 46.8178 10.7038 46.4284Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1_9034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.04777 47.9289C8.36687 46.7812 9.556 46.1094 10.7038 46.4285C11.8515 46.7476 12.5233 47.9367 12.2042 49.0845C11.8851 50.2323 10.696 50.904 9.54822 50.585C8.40045 50.2659 7.72867 49.0767 8.04777 47.9289Z",
    fill: "#C4AED4"
  }))))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1603 66.0549C88.5495 64.6547 90.0009 63.8353 91.4011 64.2246C92.8013 64.6139 93.6216 66.0648 93.2323 67.4649C92.843 68.8651 91.3916 69.6844 89.9914 69.2952C88.5912 68.9059 87.771 67.455 88.1603 66.0549Z",
    fill: "#D0BEDD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3514 4.41252C16.7407 3.01232 18.1921 2.19302 19.5923 2.58229C20.9925 2.97156 21.8127 4.42242 21.4234 5.82261C21.0342 7.2228 19.5828 8.04211 18.1826 7.65284C16.7824 7.26356 15.9622 5.81271 16.3514 4.41252Z",
    fill: "#D0BEDD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6408 39.616C93.8781 38.7626 94.7623 38.2631 95.6157 38.5004C96.4692 38.7376 96.9687 39.6218 96.7314 40.4753C96.4942 41.3287 95.61 41.8282 94.7565 41.591C93.9031 41.3537 93.4035 40.4695 93.6408 39.616Z",
    fill: "#D0BEDD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M95.548 32.9608C95.9372 31.5606 97.3886 30.7413 98.7888 31.1306C100.189 31.5199 101.009 32.9707 100.62 34.3709C100.231 35.7711 98.7793 36.5904 97.3791 36.2012C95.9789 35.8119 95.1587 34.361 95.548 32.9608Z",
    fill: "#D0BEDD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1_9034",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 53,
    width: 21,
    height: 29
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7403 53.3057L92.4774 56.8468L85.6035 81.5717L72.8664 78.0306L79.7403 53.3057Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1_9034)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1_9034",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 26,
    width: 54,
    height: 55
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5284 62.9804L65.3431 26.4191L99.5713 44.0317L80.7566 80.5931L46.5284 62.9804Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1_9034)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1_9034",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 26,
    width: 54,
    height: 55
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5284 62.9804L65.3431 26.4191L99.5713 44.0317L80.7566 80.5931L46.5284 62.9804Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1_9034)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.7857 77.0124C74.0697 76.6439 73.7881 75.7648 74.1566 75.0488L83.8861 56.1437C84.2546 55.4276 85.1339 55.1459 85.8499 55.5145L90.4229 57.8684C91.1389 58.2369 91.4205 59.116 91.0521 59.832L81.3225 78.7371C80.954 79.4532 80.0747 79.7349 79.3587 79.3663L74.7857 77.0124Z",
    fill: "#FFB43C"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1_9034",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 33,
    width: 27,
    height: 45
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1658 33.4692L90.8998 37.8435L79.7558 77.9279L64.0217 73.5536L75.1658 33.4692Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1_9034)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_1_9034",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 26,
    width: 54,
    height: 55
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5286 62.9803L65.3432 26.4189L99.5714 44.0315L80.7567 80.5929L46.5286 62.9803Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_1_9034)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_1_9034",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 26,
    width: 54,
    height: 55
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5286 62.9803L65.3432 26.4189L99.5714 44.0315L80.7567 80.5929L46.5286 62.9803Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_1_9034)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.828 72.4031C65.1121 72.0345 64.8304 71.1554 65.1988 70.4394L82.3027 37.2017C82.6711 36.4857 83.5502 36.2039 84.2663 36.5723L88.8394 38.9252C89.5555 39.2936 89.8374 40.1728 89.4689 40.8889L72.3648 74.1276C71.9963 74.8438 71.1171 75.1255 70.401 74.7569L65.828 72.4031Z",
    fill: "#FFB43C"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_1_9034",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 54,
    y: 36,
    width: 25,
    height: 37
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7698 36.3546L78.0054 40.3123L68.9443 72.9042L54.7087 68.9465L63.7698 36.3546Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_1_9034)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask10_1_9034",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 26,
    width: 54,
    height: 55
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M46.435 62.9542L65.2497 26.3929L99.4779 44.0055L80.6632 80.5669L46.435 62.9542Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_1_9034)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask11_1_9034",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 26,
    width: 54,
    height: 55
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M46.435 62.9542L65.2497 26.3929L99.4779 44.0055L80.6632 80.5669L46.435 62.9542Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_1_9034)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.7771 67.7678C56.061 67.3994 55.7792 66.5201 56.1477 65.804L69.5643 39.7327C69.9328 39.0168 70.8119 38.735 71.5279 39.1034L76.1011 41.4563C76.8172 41.8247 77.099 42.7039 76.7305 43.42L63.3138 69.4913C62.9454 70.2073 62.0663 70.4891 61.3502 70.1207L56.7771 67.7678Z",
    fill: "#FFB43C"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_1_9034",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 79,
    height: 86
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0594 1.20467L78.9987 17.8687L59.9393 86.4242L-2.13621e-06 69.7602L19.0594 1.20467Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_1_9034)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask13_1_9034",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 1,
    width: 58,
    height: 77
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2151 1.6656L68.3035 5.07227L63.5838 77.2393L11.4954 73.8326L16.2151 1.6656Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_1_9034)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask14_1_9034",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 1,
    width: 58,
    height: 77
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2151 1.6656L68.3035 5.07227L63.5838 77.2393L11.4954 73.8326L16.2151 1.6656Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_1_9034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.7959 71.9398C63.607 74.8195 61.12 77.0004 58.2417 76.8119L16.7036 74.095C13.8235 73.9076 11.6411 71.4201 11.83 68.5404L15.2783 15.8204C15.4672 12.9407 17.9528 10.7594 20.8329 10.9468L62.3711 13.6637C65.2508 13.8526 67.4317 16.3397 67.2431 19.2179L63.7959 71.9398Z",
    fill: "#662D91"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_1_9034",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 2,
    width: 71,
    height: 80
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4313 2.142L74.8781 16.723L56.9643 81.1577L4.51747 66.5767L22.4313 2.142Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_1_9034)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask16_1_9034",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 1,
    width: 58,
    height: 77
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2153 1.66557L68.3037 5.07224L63.584 77.2392L11.4956 73.8326L16.2153 1.66557Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_1_9034)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask17_1_9034",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: -25,
    width: 180,
    height: 103
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2153 1.66558L68.3037 5.07224L63.584 77.2392L11.4956 73.8326L16.2153 1.66558Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_1_9034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2246 10.9069L62.9812 13.704L59.1248 72.6606L16.3679 69.865L20.2246 10.9069Z",
    fill: "#EFEFEF"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_1_9034",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 0,
    width: 34,
    height: 26
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6945 0L58.0417 7.60295L53.1467 25.2101L25.7994 17.6072L30.6945 0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_1_9034)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask19_1_9034",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 1,
    width: 58,
    height: 77
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M16.215 1.66555L68.3035 5.07221L63.5837 77.2392L11.4953 73.8325L16.215 1.66555Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_1_9034)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask20_1_9034",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 1,
    width: 58,
    height: 77
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M16.215 1.66555L68.3035 5.07221L63.5837 77.2392L11.4953 73.8325L16.215 1.66555Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_1_9034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.5847 10.4524C46.7825 9.96198 46.9083 9.43573 46.9446 8.87987C47.1301 6.06383 44.9967 3.63257 42.1817 3.44902C39.3657 3.2636 36.9344 5.39693 36.7505 8.21339C36.7142 8.76924 36.7708 9.30838 36.9015 9.81923L28.3686 9.26149L27.8089 17.8127L54.5593 19.5618L55.119 11.0106L46.5847 10.4524ZM39.6692 8.40371C39.7482 7.20077 40.787 6.28829 41.9899 6.36734C43.1929 6.44639 44.1054 7.48515 44.0263 8.68809C43.9855 9.31679 43.6808 9.86267 43.2312 10.2327L40.2569 10.0379C39.8579 9.61329 39.6288 9.03095 39.6692 8.40371Z",
    fill: "#662D91"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_1_9034",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 32,
    width: 10,
    height: 12
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8683 32.2622L44.2368 34.0328L41.6331 43.3983L35.2645 41.6277L37.8683 32.2622Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_1_9034)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask22_1_9034",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 1,
    width: 58,
    height: 77
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2153 1.66522L68.3037 5.07189L63.584 77.2389L11.4956 73.8322L16.2153 1.66522Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_1_9034)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask23_1_9034",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 1,
    width: 58,
    height: 77
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2153 1.66522L68.3037 5.07189L63.584 77.2389L11.4956 73.8322L16.2153 1.66522Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_1_9034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.0288 39.4061L38.4231 42.4412L43.9839 33.9955",
    fill: "#662D91"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_1_9034",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 45,
    width: 34,
    height: 18
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7736 45.9752L55.1178 54.4114L52.8265 62.653L22.4823 54.2169L24.7736 45.9752Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_1_9034)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask25_1_9034",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 1,
    width: 58,
    height: 77
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2153 1.66503L68.3037 5.07169L63.584 77.2387L11.4956 73.832L16.2153 1.66503Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_1_9034)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask26_1_9034",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 1,
    width: 58,
    height: 77
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2153 1.66503L68.3037 5.07169L63.584 77.2387L11.4956 73.832L16.2153 1.66503Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_1_9034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2739 52.4806L54.5407 54.5252L54.4208 56.3569L23.1541 54.3122L23.2739 52.4806Z",
    fill: "#662D91"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_1_9034",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 50,
    width: 33,
    height: 18
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6475 50.7833L54.9917 59.2195L52.7004 67.4611L22.3562 59.025L24.6475 50.7833Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_1_9034)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask28_1_9034",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 1,
    width: 58,
    height: 77
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2151 1.66523L68.3035 5.07189L63.5838 77.2389L11.4954 73.8322L16.2151 1.66523Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_1_9034)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask29_1_9034",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 1,
    width: 58,
    height: 77
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2151 1.66523L68.3035 5.07189L63.5838 77.2389L11.4954 73.8322L16.2151 1.66523Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_1_9034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9728 57.0903L54.2395 59.1349L54.1197 60.9666L22.853 58.9219L22.9728 57.0903Z",
    fill: "#662D91"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_1_9034",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 38,
    width: 8,
    height: 7
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6851 39.6204L7.0658 38.0582L5.6077 43.3029L11.227 44.8651L12.6851 39.6204Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_1_9034)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask31_1_9034",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 38,
    width: 8,
    height: 7
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M7.24738 38.1307L12.3194 39.5408L10.9097 44.6114L5.83769 43.2013L7.24738 38.1307Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_1_9034)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask32_1_9034",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 38,
    width: 6,
    height: 7
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M9.78338 38.8358C8.38294 38.4464 6.93208 39.2648 6.54233 40.6667C6.15299 42.0672 6.97326 43.517 8.37369 43.9063C9.77413 44.2957 11.225 43.4773 11.6143 42.0768C12.0041 40.6749 11.1838 39.2251 9.78338 38.8358Z",
    fill: "white"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_1_9034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.24725 38.1307L12.3193 39.5408L10.9096 44.6113L5.83757 43.2012L7.24725 38.1307Z",
    fill: "#D0BEDD"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30.5035,
    y: 31.5437,
    width: 14,
    height: 13,
    transform: "rotate(-6.06901 30.5035 31.5437)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask33_1_9034",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 22,
    width: 29,
    height: 28
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7864 25.0058L50.6463 22.3626L53.2894 47.2225L28.4295 49.8656L25.7864 25.0058Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_1_9034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.991 28.8468C28.7534 28.6473 28.7259 28.2885 28.9351 28.0592C30.9328 25.8724 33.6621 24.3392 36.7914 23.8728C37.099 23.8271 37.3827 24.0495 37.4155 24.3585L38.6202 35.6893C38.6724 36.1801 38.1007 36.4846 37.7225 36.1678L28.991 28.8468ZM56.5607 27.016L54.6162 27.2227C54.4868 27.2365 54.3932 27.3523 54.407 27.4818L54.6138 29.4267C54.6275 29.5557 54.7434 29.6497 54.8728 29.636L56.8173 29.4292C56.9468 29.4155 57.0403 29.2992 57.0266 29.1702L56.8198 27.2252C56.806 27.0958 56.6902 27.0022 56.5607 27.016ZM37.7712 37.3165L30.2112 30.9774C29.9721 30.7772 29.6115 30.8136 29.4235 31.063C27.7961 33.2211 26.953 35.9783 27.2613 38.8778C27.5074 41.1928 28.4515 43.2641 29.862 44.9042C30.0649 45.1403 30.4266 45.1534 30.6518 44.9391L37.7973 38.1337C38.0343 37.9079 38.022 37.5266 37.7712 37.3165ZM57.4125 35.0271L55.468 35.2339C55.3385 35.2476 55.245 35.3639 55.2588 35.4934L55.4655 37.4378C55.4793 37.5673 55.5951 37.6609 55.7246 37.6471L57.6691 37.4404C57.7985 37.4266 57.8921 37.3108 57.8783 37.1813L57.6716 35.2368C57.6578 35.1074 57.542 35.0133 57.4125 35.0271ZM39.0356 25.5467C38.725 25.5644 38.4946 25.8429 38.5275 26.1524L39.6169 36.3982C39.6489 36.6994 39.9191 36.9177 40.2203 36.8857L50.4652 35.7964C50.7742 35.7636 50.998 35.4797 50.95 35.1723C50.0458 29.384 44.8843 25.2142 39.0356 25.5467ZM57.8384 39.0331L55.8939 39.2399C55.7645 39.2536 55.6709 39.3695 55.6847 39.4989L55.8914 41.4434C55.9052 41.5729 56.021 41.6669 56.1505 41.6531L58.095 41.4464C58.2245 41.4326 58.318 41.3164 58.3042 41.1869L58.0975 39.2424C58.0837 39.1129 57.9679 39.0194 57.8384 39.0331ZM49.2283 36.9281L39.3888 37.9742C39.2685 37.987 39.1561 38.0394 39.0689 38.1225L31.9027 44.9472C31.6767 45.1626 31.673 45.5256 31.9001 45.7397C34.0823 47.7954 37.1153 48.9221 40.3293 48.5804C45.9851 47.9791 50.132 43.0527 49.8343 37.4394C49.8178 37.1278 49.5391 36.895 49.2283 36.9281ZM58.2187 28.3116L64.3308 27.6618C64.4681 27.6472 64.5678 27.5237 64.5532 27.3865C64.5386 27.2492 64.4152 27.1495 64.2779 27.1641L58.1658 27.8139C58.0285 27.8285 57.9288 27.9519 57.9434 28.0892C57.958 28.2265 58.0814 28.3262 58.2187 28.3116ZM56.9866 31.0215L55.0421 31.2283C54.9126 31.242 54.8191 31.3583 54.8329 31.4873L55.0397 33.4323C55.0534 33.5618 55.1692 33.6553 55.2987 33.6415L57.2432 33.4348C57.3727 33.421 57.4662 33.3052 57.4525 33.1757L57.2457 31.2308C57.2319 31.1018 57.1161 31.0078 56.9866 31.0215ZM64.7038 31.1696L58.5917 31.8195C58.4544 31.8341 58.3547 31.9575 58.3693 32.0948C58.3839 32.2321 58.5073 32.3318 58.6446 32.3172L64.7567 31.6673C64.894 31.6527 64.9937 31.5293 64.9791 31.392C64.9645 31.2547 64.8411 31.155 64.7038 31.1696ZM65.1297 35.1752L59.0176 35.8251C58.8803 35.8397 58.7806 35.9631 58.7952 36.1004C58.8098 36.2381 58.9332 36.3378 59.0705 36.3232L65.1826 35.6734C65.3199 35.6588 65.4196 35.5353 65.405 35.3976C65.3904 35.2603 65.267 35.1606 65.1297 35.1752ZM65.5556 39.1812L59.4435 39.8311C59.3062 39.8457 59.2064 39.9687 59.2211 40.1064C59.2357 40.2437 59.3591 40.3434 59.4964 40.3288L65.6085 39.6789C65.7458 39.6643 65.8455 39.5409 65.8309 39.4036C65.8163 39.2659 65.6929 39.1666 65.5556 39.1812Z",
    fill: "#5285FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask34_1_9034",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 22,
    width: 24,
    height: 16
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3721 24.7308L50.6461 22.3626L51.9801 34.9092L29.7061 37.2774L28.3721 24.7308Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_1_9034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.4157 24.3585L38.6204 35.6892C38.6726 36.1801 38.1009 36.4846 37.7226 36.1678L28.9911 28.8468C28.7536 28.6473 28.7261 28.2885 28.9353 28.0591C30.933 25.8724 33.6623 24.3392 36.7915 23.8728C37.0992 23.827 37.3828 24.0495 37.4157 24.3585ZM56.5609 27.016L54.6164 27.2227C54.4869 27.2365 54.3934 27.3523 54.4071 27.4818L54.6139 29.4267C54.6276 29.5557 54.7435 29.6497 54.873 29.636L56.8175 29.4292C56.9469 29.4154 57.0405 29.2992 57.0267 29.1702L56.8199 27.2252C56.8062 27.0957 56.6904 27.0022 56.5609 27.016Z",
    fill: "#FFB43C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask35_1_9034",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 28,
    width: 27,
    height: 18
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4455 31.2051L51.3054 28.562L52.8175 42.7844L27.9577 45.4276L26.4455 31.2051Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_1_9034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.7712 37.3163C38.022 37.5264 38.0342 37.9077 37.7973 38.1335L30.6518 44.9389C30.4266 45.1532 30.0649 45.1401 29.862 44.904C28.4515 43.2639 27.5074 41.1926 27.2613 38.8776C26.953 35.9781 27.7961 33.2209 29.4235 31.0628C29.6115 30.8135 29.9721 30.777 30.2112 30.9772L37.7712 37.3163ZM57.4125 35.0269L55.468 35.2337C55.3385 35.2474 55.245 35.3637 55.2588 35.4932L55.4655 37.4377C55.4793 37.5671 55.5951 37.6607 55.7246 37.6469L57.6691 37.4402C57.7985 37.4264 57.8921 37.3106 57.8783 37.1811L57.6716 35.2367C57.6578 35.1072 57.542 35.0132 57.4125 35.0269Z",
    fill: "#984FFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask36_1_9034",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 24,
    width: 15,
    height: 20
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4425 25.5313L50.8431 24.2129L52.7426 42.0791L40.3421 43.3975L38.4425 25.5313Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_1_9034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.9502 35.1726C50.9982 35.48 50.7744 35.7638 50.4654 35.7967L40.2205 36.8859C39.9193 36.918 39.6491 36.6997 39.6171 36.3985L38.5277 26.1527C38.4948 25.8432 38.7252 25.5647 39.0359 25.547C44.8845 25.2145 50.046 29.3843 50.9502 35.1726ZM57.8386 39.0334L55.8942 39.2402C55.7647 39.2539 55.6711 39.3697 55.6849 39.4992L55.8916 41.4437C55.9054 41.5732 56.0213 41.6672 56.1508 41.6534L58.0952 41.4467C58.2247 41.4329 58.3182 41.3166 58.3044 41.1872L58.0977 39.2427C58.0839 39.1132 57.9681 39.0197 57.8386 39.0334Z",
    fill: "#1DDD92"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTourIconThree);
export default __webpack_public_path__ + "static/media/tour_icon_three.8ab1f5cb6fb3edb652922f700f19b48f.svg";
export { ForwardRef as ReactComponent };